import { render, staticRenderFns } from "./ATXPanel.vue?vue&type=template&id=5264fcc2&scoped=true"
import script from "./ATXPanel.vue?vue&type=script&lang=ts"
export * from "./ATXPanel.vue?vue&type=script&lang=ts"
import style0 from "./ATXPanel.vue?vue&type=style&index=0&id=5264fcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264fcc2",
  null
  
)

export default component.exports